import { Box, Select, createListCollection } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import { PROJECT_ROLE_OPTIONS, ProjectRoleValue } from '../types';

type CollaboratorRoleSelectProps = {
  value: ProjectRoleValue;
  onChange: (value: ProjectRoleValue) => void;
  disabled?: boolean;
  minWidth?: string;
};

const CollaboratorRoleSelect: FC<CollaboratorRoleSelectProps> = ({
  value,
  onChange,
  disabled,
  minWidth = '180px',
}) => {
  const roleCollection = useMemo(
    () =>
      createListCollection({
        items: PROJECT_ROLE_OPTIONS,
      }),
    []
  );

  return (
    <Box display="inline-block" minW={minWidth}>
      <Select.Root
        collection={roleCollection}
        value={[value]}
        onValueChange={(details) => {
          const [next] = details.value as ProjectRoleValue[];
          if (next) {
            onChange(next);
          }
        }}
        disabled={disabled}
        size="sm"
      >
        <Select.HiddenSelect />
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText placeholder="Select role" />
            <Select.Indicator />
          </Select.Trigger>
        </Select.Control>
        <Select.Positioner>
          <Select.Content>
            {roleCollection.items.map((role) => (
              <Select.Item item={role} key={role.value}>
                {role.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </Box>
  );
};

export default CollaboratorRoleSelect;
